import Vue from 'vue';
import { Company, AuthUser } from '../models';
import { Module, ActionContext } from 'vuex';
import { OnboardingState, RootState } from '../store/state_models';
import { OnboardingService } from '../services';

let unsubscribe: () => void;

export const onboarding: Module<OnboardingState, RootState> = {
	namespaced: true,
	state: {
    emailVerified: false,
    phoneNumberVerified: false
  },
	actions: {
		verifyStatus: {
			handler: (context: ActionContext<OnboardingState, RootState>): Promise<OnboardingState> => {
				return new Promise(async (resolve, reject) => {
					try {
						let credentials = new AuthUser(await context.dispatch('auth/get', null, { root: true }));
            			const { data } = await OnboardingService.verifyStatus(credentials.companyId)
						resolve({
							emailVerified: data.emailVerified || false,
							phoneNumberVerified: data.phoneNumberVerified || false
						});
					} catch (e) {
            			resolve({ emailVerified: false, phoneNumberVerified: false})
					}
				});
			},
		},
	},
};
